<template>
  <div v-if="isVisible" class="image-preview-overlay" @click="closePreview">
    <div class="image-preview-container" @click.stop>
      <van-swipe v-model="currentIndex" @change="handleChange" :show-indicators="false">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img :src="image" class="preview-image" />
        </van-swipe-item>
      </van-swipe>
      <div class="image-index">{{ currentIndex + 1 }}/{{ images.length }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImagePreviewComponent',
  props: {
    images: {
      type: Array,
      default: () => []
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isVisible: true,
      currentIndex: this.initialIndex
    };
  },
  methods: {
    closePreview() {
      this.isVisible = false;
      this.$emit('close');
    },
    handleChange(index) {
      this.currentIndex = index;
    }
  }
};
</script>

<style scoped lang="less">
.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000001;
  cursor: pointer;
}

.image-preview-container {
  width: 750px;
  max-height: 100%;
  overflow: hidden;
}

.preview-image {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.image-index {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 26px;
}
</style>